<template>
  <div class="home">
    <!-- Navigation -->
    <nav class="nav" id="nav" :class="{ scrolled: scrolled }">
      <div class="nav-inner">
        <a href="#top" class="nav-logo">
          <div class="nav-logo-icon">养</div>
          <div class="nav-logo-text">
            <span class="nav-logo-title">2026安徽省养老博览会</span>
            <span class="nav-logo-sub">ANHUI ELDERLY CARE EXPO 2026</span>
          </div>
        </a>
        <ul class="nav-links">
          <li v-for="link in navLinks" :key="link.href">
            <a
              :href="link.href"
              class="nav-link"
              :class="{
                'nav-cta': link.cta,
                active: !link.cta && activeSection === link.section,
              }"
            >
              {{ link.text }}<span v-if="link.cta"> →</span>
            </a>
          </li>
        </ul>
        <button
          class="nav-mobile-toggle"
          aria-label="菜单"
          @click="toggleMobileMenu"
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </nav>

    <div class="nav-mobile-menu" :class="{ open: mobileMenuOpen }">
      <a
        v-for="link in mobileLinks"
        :key="link.href"
        :href="link.href"
        class="nav-mobile-link"
        :style="link.style"
        @click="closeMobileMenu"
        >{{ link.text }}</a
      >
    </div>

    <!-- Hero -->
    <section class="hero" id="top">
      <img src="/images/bg.jpg" alt="2026安徽省养老博览会" class="hero-bg" />
      <div class="hero-pattern"></div>
      <div class="hero-banner-title">2026安徽省养老博览会</div>
      <div class="hero-inner">
        <div class="hero-left">
          <div class="hero-badge">
            <span class="hero-badge-dot"></span>
            展会邀约中 · 诚邀莅临
          </div>
          <h1 class="hero-title">
            皖美养老<br />
            <span class="hero-title-accent">人生晚晴</span>
          </h1>
          <p class="hero-subtitle">
            <!-- 2026安徽省养老博览会<br /> -->
            立足安徽养老产业发展实际，深度联动长三角康养资源，全方位展示养老事业建设成果与银发经济创新业态
          </p>
          <div class="hero-info-grid">
            <div
              class="hero-info-card"
              v-for="info in heroInfo"
              :key="info.label"
            >
              <div class="hero-info-label">{{ info.label }}</div>
              <div class="hero-info-value">{{ info.value }}</div>
            </div>
          </div>
          <div class="hero-features">
            <a
              v-for="feature in heroFeatures"
              :key="feature.path"
              :href="feature.path"
              class="hero-feature"
            >
              <span class="hero-feature-icon">{{ feature.icon }}</span>
              <span class="hero-feature-text">{{ feature.text }}</span>
            </a>
          </div>
          <div class="hero-actions">
            <a href="#register" class="btn btn-primary">
              立即参观报名
              <span class="btn-arrow">→</span>
            </a>
            <a href="#overview" class="btn btn-secondary"> 了解展会详情 </a>
          </div>
        </div>

        <div class="hero-visual">
          <div class="hero-float hero-float-1">
            <span class="hero-float-icon">🎯</span>
            <span class="hero-float-text">300+ 康养品牌</span>
          </div>
          <div class="hero-float hero-float-2">
            <span class="hero-float-icon">👥</span>
            <span class="hero-float-text">多部门联合主办</span>
          </div>
          <div class="hero-card-main">
            <div class="hero-card-inner">
              <div class="hero-card-header">
                <div class="hero-card-seal">2026<br />养老展</div>
                <div class="hero-card-header-text">
                  <span class="hero-card-tag">OFFICIAL INVITATION</span>
                  <h3 class="hero-card-title">2026安徽省养老博览会邀请函</h3>
                </div>
              </div>
              <div class="hero-stats">
                <div
                  class="hero-stat"
                  v-for="stat in heroStats"
                  :key="stat.label"
                >
                  <div class="hero-stat-num">{{ stat.num }}</div>
                  <div class="hero-stat-label">{{ stat.label }}</div>
                </div>
              </div>
              <div class="hero-card-divider"></div>
              <div class="hero-card-organizers">
                <div
                  class="hero-card-organizer"
                  v-for="(org, idx) in organizers"
                  :key="idx"
                >
                  <div class="hero-card-organizer-icon">★</div>
                  <span>{{ org }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 展会概况 -->
    <OverviewSection />

    <!-- 展会资讯 -->
    <NewsSection />

    <!-- 日程安排 -->
    <section class="section" id="activity">
      <div class="section-inner">
        <div class="section-header reveal">
          <div class="section-number">03 / SCHEDULE</div>
          <h2 class="section-title">日程安排</h2>
          <p class="section-desc">
            一览展会各日详细安排，精准规划您的参展行程
          </p>
        </div>
        <div class="schedule-img-wrap reveal">
          <img
            src="/images/schedule_img.jpg"
            alt="2026安徽省养老博览会日程安排"
            class="schedule-img"
          />
        </div>
      </div>
    </section>

    <!-- 平面图 -->
    <FloorplanSection />

    <!-- 参观报名 -->
    <RegisterForm />

    <!-- Footer -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-partners footer-partners-inline">
          <div class="footer-partners-title">大会推荐搭建商</div>
          <div class="footer-partners-grid footer-partners-grid-inline">
            <div class="footer-partner-card">
              <div class="footer-partner-name">安徽天艺展览服务有限公司</div>
              <div class="footer-partner-contact">
                <span class="footer-partner-contact-name">兰鸿婷</span>
                <a href="tel:18788859372" class="footer-partner-contact-phone">18788859372</a>
              </div>
            </div>
            <div class="footer-partner-card">
              <div class="footer-partner-name">合肥承亿文化传媒有限公司</div>
              <div class="footer-partner-contact">
                <span class="footer-partner-contact-name">刘&nbsp;&nbsp;&nbsp;&nbsp;宇</span>
                <a href="tel:15395003733" class="footer-partner-contact-phone">15395003733</a>
              </div>
            </div>
            <div class="footer-partner-card">
              <div class="footer-partner-name">安徽千琪文化科技有限公司</div>
              <div class="footer-partner-contact">
                <span class="footer-partner-contact-name">谢&nbsp;&nbsp;&nbsp;&nbsp;诚</span>
                <a href="tel:13866684229" class="footer-partner-contact-phone">13866684229</a>
              </div>
            </div>
            <div class="footer-partner-card">
              <div class="footer-partner-name">合肥易派传媒有限公司</div>
              <div class="footer-partner-contact">
                <span class="footer-partner-contact-name">王&nbsp;&nbsp;&nbsp;&nbsp;宇</span>
                <a href="tel:15256577531" class="footer-partner-contact-phone">15256577531</a>
              </div>
            </div>
            <div class="footer-partner-card">
              <div class="footer-partner-name">安徽中设国际会展集团有限公司</div>
              <div class="footer-partner-contact">
                <span class="footer-partner-contact-name">张&nbsp;&nbsp;&nbsp;&nbsp;艳</span>
                <a href="tel:18955126238" class="footer-partner-contact-phone">18955126238</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-grid">
          <div class="footer-brand">
            <div class="footer-logo">
              <div class="footer-logo-icon">养</div>
              <span class="footer-logo-text">2026安徽省养老博览会</span>
            </div>
            <p>
              立足安徽、辐射长三角，打造养老产业展示、招商对接与惠民服务核心平台。让我们携手共赴银发经济新时代，共绘皖美养老新蓝图。
            </p>
            <p
              style="
                color: var(--color-accent);
                font-family: var(--font-serif);
                font-weight: 700;
              "
            >
              皖美养老 · 人生晚晴
            </p>
          </div>
          <div>
            <h5 class="footer-heading">快速导航</h5>
            <ul class="footer-links footer-nav-cols">
              <li v-for="link in footerNavLinks" :key="link.text">
                <a :href="link.href">{{ link.text }}</a>
              </li>
            </ul>
          </div>
          <div>
            <h5 class="footer-heading">联系我们</h5>
            <div
              class="footer-contact-item"
              v-for="(contact, idx) in footerContacts"
              :key="idx"
            >
              <svg viewBox="0 0 24 24" v-html="contact.icon"></svg>
              <span v-html="contact.text"></span>
            </div>
            <div class="footer-wechat">
              <div class="footer-wechat-qr">
                <img src="/images/wechat_qrcode.png" alt="微信二维码" />
              </div>
              <div class="footer-wechat-info">
                <div class="footer-wechat-title">扫码添加微信</div>
                <div class="footer-wechat-name">联系人：王艳</div>
                <div class="footer-wechat-desc">15055191960</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="footer-icp">皖ICP备12010259号-44</a>
            <span class="footer-icp-sep">|</span>
            <a href="https://beian.mps.gov.cn/" target="_blank" rel="noopener noreferrer" class="footer-icp">公安备案</a>
          </p>
          <p>© 2026 ict-expo.cn, all rights reserved</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import OverviewSection from "../components/OverviewSection.vue";
import NewsSection from "../components/NewsSection.vue";
import FloorplanSection from "../components/FloorplanSection.vue";
import RegisterForm from "../components/RegisterForm.vue";

export default {
  name: "Home",
  components: {
    OverviewSection,
    NewsSection,
    FloorplanSection,
    RegisterForm,
  },
  data() {
    return {
      scrolled: false,
      mobileMenuOpen: false,
      activeSection: "",
      navLinks: [
        {
          href: "#overview",
          text: "展会概况",
          section: "overview",
          cta: false,
        },
        { href: "#news", text: "展会资讯", section: "news", cta: false },
        {
          href: "#activity",
          text: "日程安排",
          section: "activity",
          cta: false,
        },
        {
          href: "#floorplan",
          text: "平面图",
          section: "floorplan",
          cta: false,
        },
        { href: "#register", text: "立即报名", section: "register", cta: true },
      ],
      mobileLinks: [
        { href: "#overview", text: "展会概况", style: "" },
        { href: "#news", text: "展会资讯", style: "" },
        { href: "#activity", text: "日程安排", style: "" },
        { href: "#floorplan", text: "平面图", style: "" },
        {
          href: "#register",
          text: "立即报名 →",
          style: "color: var(--color-primary); font-weight: 700;",
        },
      ],
      heroInfo: [
        { label: "展会时间", value: "2026.9.11-12" },
        { label: "展会地点", value: "合肥滨湖国际会展中心" },
        { label: "展会规模", value: "10,000㎡ 展区" },
      ],
      heroStats: [
        { num: "1万㎡", label: "展览面积" },
        { num: "300+", label: "康养品牌" },
        { num: "8", label: "核心板块" },
        { num: "4", label: "养老场景" },
      ],
      organizers: [
        "省民政厅 · 省卫生健康委 · 省发展改革委",
        "省商务厅 · 省贸促会 联合主办",
        "经商务部核准 · 长三角区域极具影响力",
      ],
      heroFeatures: [
        { icon: "🖥", text: "云展览", path: "#/exhibit-all" },
        { icon: "📷", text: "云相册", path: "#/cloud-album" },
        { icon: "🎥", text: "云论坛", path: "#/cloud-forum" },
        { icon: "📢", text: "云发布", path: "#/cloud-release" },
      ],
      footerNavLinks: [
        { href: "#overview", text: "展会概况" },
        { href: "#news", text: "展会资讯" },
        { href: "#activity", text: "日程安排" },
        { href: "#floorplan", text: "平面图" },
        { href: "#register", text: "立即报名 →" },
      ],
      footerContacts: [
        {
          icon: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
          text: "联系人：王艳<br>电话：15055191960",
        },
        {
          icon: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
          text: "邮箱：1123047810@qq.com",
        },
        {
          icon: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
          text: "合肥滨湖国际会展中心<br>安徽省合肥市包河区锦绣大道3899号",
        },
      ],
    };
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;

      const sections = document.querySelectorAll("section[id]");
      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 120;
        if (window.scrollY >= sectionTop) {
          current = section.getAttribute("id");
        }
      });
      this.activeSection = current;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    // 观察 Home 自身模板中的 .reveal 元素（如日程图片），进入视口时加 .visible 显现
    this.revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            this.revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    this.$el.querySelectorAll(".reveal").forEach((el) =>
      this.revealObserver.observe(el)
    );
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.revealObserver) this.revealObserver.disconnect();
  },
};
</script>

<style scoped>
/* ====== 日程安排图片展示 ====== */
.schedule-img-wrap {
  max-width: 1000px;
  margin: 0 auto;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
  background: #fff;
}
.schedule-img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.4s ease;
}
.schedule-img-wrap:hover .schedule-img {
  transform: scale(1.015);
}
</style>
